<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <h1 class="display-2 text-white font-size-20">
              <span class="text-white"
                >Olá,
                <span class="text-warning d-inline">{{
                  model.investor.name.split(" ")[0]
                }}</span
                >! :)</span
              >
            </h1>
            <p class="text-white mt-4 mb-2">
              Aqui você pode conferir a atualizar as informações básicas de sua
              conta. Além disso, você também pode modificar a foto de perfil e
              alterar sua senha de usuário.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div
            class="card card-profile shadow vld-parent"
            ref="investor_profile_picture"
          >
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <img :src="getprofilePicturePath" />
                </div>
              </div>
            </div>
            <div class="card-body pt-6 pb-1">
              <div class="row">
                <div class="col">
                  <div class="text-center mt-6">
                    <h2 class="text-orange">
                      {{ model.investor.name }}
                    </h2>
                    <div class="h5 font-weight-300">
                      <i class="ni ni-pin-3 mr-2"></i
                      >{{ model.investor.city || "..." }},
                      {{ model.investor.state || "..." }}
                    </div>
                    <div>
                      <div class="h5 font-weight-300 mb-1">
                        <i class="fas fa-envelope mr-2"></i>
                        {{ model.investor.email }}
                      </div>
                    </div>
                    <div class="h5 mt-2" v-if="model.investor.working_place">
                      <badge
                        type="info"
                        class="text-dark"
                        title="Local de trabalho"
                      >
                        <i class="fas fa-briefcase mr-1"></i>
                        <span class="font-weight-bold">
                          {{ model.investor.working_place }}
                        </span>
                      </badge>
                    </div>
                    <hr class="mt-3 mb-4" />
                    <div class="row">
                      <div class="col">
                        <file-select
                          v-model="model.profilePicture"
                          title="Selecione sua foto de perfil"
                          accept="image/*"
                          :mbSize="2"
                        ></file-select>
                        <br />
                        <button
                          v-if="model.profilePicture"
                          @click="handleSubmitProfilePicture"
                          class="btn btn-primary my-2 jump"
                        >
                          Salvar arquivo
                        </button>
                      </div>
                    </div>
                    <p class="text-sm text-muted">
                      <i class="fas fa-info-circle mr-1"></i> A foto de perfil
                      deve possuir tamanho máximo de 2MB e, preferencialmente,
                      ser formato <b>PNG</b> ou <b>JPG</b> com dimensão de
                      <b>500x500 pixels</b>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-8 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Meu perfil</h3>
                </div>
                <div class="col-4 text-right">
                  <span class="btn btn-sm btn-primary">Edição</span>
                </div>
              </div>
            </div>
            <template>
              <form role="form" class="vld-parent" ref="investor_form">
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Informações básicas
                  </h6>
                </div>
                <div class="row ml-2">
                  <div class="col-lg-12">
                    <base-input
                      label="Nome*"
                      v-model="model.investor.name"
                      placeholder="Nome completo"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="CPF"
                      v-model="model.investor.cpf"
                      placeholder="Digite seu CPF"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Data de nascimento*"
                      type="date"
                      v-model="model.investor.birthday"
                      placeholder="Data de nascimento"
                    />
                  </div>
                  <div class="col-lg-12">
                    <estados
                      estadoLabel="Estado*"
                      cidadeLabel="Cidade*"
                      :selectedEstado="model.investor.state"
                      :selectedCidade="model.investor.city"
                      @inputEstado="handleStateChange"
                      @inputCidade="handleCityChange"
                    />
                  </div>
                  <div class="col-lg-12">
                    <div
                      v-show="originalLocation.show"
                      class="col text-sm text-right"
                    >
                      <i class="ni ni-pin-3 mr-1"></i> Localização original:
                      {{ local() }}.
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Informações complementares
                  </h6>
                </div>
                <div class="row ml-2">
                  <div class="col-lg-6">
                    <base-input
                      label="Profissão"
                      v-model="model.investor.occupation"
                      placeholder="Qual sua profissão/ocupação?"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Local de trabalho"
                      v-model="model.investor.working_place"
                      placeholder="Qual o nome do local onde você trabalha?"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Telefone pessoal"
                      v-model="model.investor.phone"
                      placeholder="Telefone com DDD"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Telefone comercial"
                      v-model="model.investor.commercial_phone"
                      placeholder="Telefone comercial com DDD"
                    />
                  </div>
                </div>
                <div class="row ml-2">
                  <div class="col-12 text-center" v-if="error">
                    <base-alert type="danger">{{ error }}</base-alert>
                  </div>
                  <div class="col-12 text-center" v-if="success">
                    <base-alert type="success">{{ success }}</base-alert>
                  </div>
                </div>
                <div class="text-right">
                  <base-button
                    type="primary"
                    :custom="true"
                    @click="handleSubmitForm"
                    >Salvar alterações</base-button
                  >
                </div>
                <hr class="my-4" />
                <div class="col-12 ml-1">
                  <h6 class="heading-small text-muted">
                    Detalhes da conta - Segurança
                    <base-button
                      type="dark"
                      size="sm"
                      class="float-right mt-4 mt-md--1 mt-sm--1"
                      @click="handleOpenModalChangePassword"
                      ><i class="fas fa-lock mr-2"></i> Modificar
                      senha</base-button
                    >
                  </h6>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalChangePassword"
      modal-classes="modal-dialog-centered"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_change_password">
        <div class="py-3 text-center">
          <i class="fas fa-key fa-3x"></i>
          <h4 class="heading mt-4">Modificar senha</h4>
        </div>
        <div class="py-3 text-center">
          <base-input
            type="password"
            placeholder="Senha antiga"
            addon-left-icon="ni ni-lock-circle-open"
            v-model="model.user.oldPassword"
          >
          </base-input
          ><base-input
            type="password"
            placeholder="Nova senha"
            addon-left-icon="ni ni-lock-circle-open"
            v-model="model.user.newPassword"
          >
          </base-input
          ><base-input
            type="password"
            placeholder="Confirmar nova senha"
            addon-left-icon="ni ni-lock-circle-open"
            v-model="model.user.newPasswordConfirmation"
          >
          </base-input>
          <p
            class="text-right mb-0"
            v-show="
              model.user.newPassword &&
              model.user.newPasswordConfirmation &&
              !newPasswordInputsMatch()
            "
          >
            <small>As senhas não conferem!</small>
          </p>
        </div>
        <div class="text-center" v-if="modals.modalError">
          <base-alert type="danger">{{ modals.modalError }}</base-alert>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="dark"
          class="ml-auto"
          @click="modals.modalChangePassword = false"
        >
          Voltar
        </base-button>
        <base-button
          type="default"
          :disabled="!newPasswordInputsMatch()"
          @click="handleSubmitChangePassword()"
        >
          Alterar senha
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";

export default {
  name: "investor-profile",
  data() {
    return {
      model: {
        investor: {
          name: "",
          cpf: "",
          birthday: "",
          state: "",
          city: "",
          phone: "",
          occupation: "",
          working_place: "",
          commercial_phone: "",
          profile_picture: null,
        },
        profilePicture: null,
        user: {
          oldPassword: "",
          newPassword: "",
          newPasswordConfirmation: "",
        },
      },
      requiredFields: ["name", "birthday", "state", "city"],
      error: "",
      success: "",
      originalLocation: {
        show: false,
        state: "",
        city: "",
      },
      modals: {
        modalChangePassword: false,
        modalError: "",
      },
    };
  },
  async mounted() {
    const loaderForm = this.$loading.show({
      container: this.$refs.investor_form,
      width: 90,
      height: 90,
    });
    const loaderProfilePicture = this.$loading.show({
      container: this.$refs.investor_profile_picture,
      width: 130,
      height: 130,
    });
    try {
      const { data } = await api.get("/investors");
      Object.assign(this.model.investor, data);
      this.originalLocation.state = data.state;
      this.originalLocation.city = data.city;
      loaderForm.hide();
      loaderProfilePicture.hide();
    } catch (e) {
      this.error =
        "Ocorreu um erro ao recuperar as informações de perfil do usuário.";
      this.$toasted.error("Erro ao recuperar as informações");
    }
  },
  methods: {
    async handleSubmitForm(e) {
      e.preventDefault();
      this.error = this.success = "";
      const investorData = this.model.investor;
      for (const key in investorData) {
        if (this.requiredFields.includes(key) && !investorData[key]) {
          this.error =
            "Por favor, preencha todos os campos obrigatórios antes de continuar.";
          return;
        }
      }
      const loader = this.$loading.show({
        container: this.$refs.investor_form,
        width: 90,
        height: 90,
      });
      try {
        const { data } = await api.put(
          `/investors/${this.model.investor.user_id}`,
          investorData
        );
        Object.assign(this.model.investor, data);
        this.originalLocation.state = data.state;
        this.originalLocation.city = data.city;
        this.$toasted.show("Informações atualizadas com sucesso");
        this.success = "Perfil atualizado com sucesso!";
      } catch (e) {
        this.error =
          "Não foi possível salvar as informações. Por favor, tente novamente em alguns instantes.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
      }
      loader.hide();
    },
    async handleSubmitProfilePicture() {
      this.error = this.success = "";
      const loader = this.$loading.show({
        container: this.$refs.investor_profile_picture,
        width: 90,
        height: 90,
      });
      const profilePicture = this.model.profilePicture;
      if (!profilePicture) return;
      const data = new FormData();
      data.append("profile_picture", profilePicture, profilePicture.name);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      try {
        await api.post(
          `/investors/${this.model.investor.user_id}/profile-pictures`,
          data,
          config
        );
        this.$toasted.show("Foto de prefil salva com sucesso");
        const { data: profilePictureData } = await api.get(
          `/investors/${this.model.investor.user_id}/profile-pictures`
        );
        if (profilePictureData)
          this.model.investor.profile_picture = profilePictureData;
        this.model.profilePicture = null;
        this.success = "Foto de perfil atualizada com sucesso!";
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao salvar a foto de perfil");
        this.error =
          "Não foi possível alterar a foto de perfil. Por favor, tente novamente em alguns instantes.";
      }
      loader.hide();
    },
    local() {
      return `${this.originalLocation.city}, ${this.originalLocation.state}`;
    },
    handleStateChange(newState) {
      this.model.investor.state = newState;
      this.originalLocation.show = true;
    },
    handleCityChange(newCity) {
      this.model.investor.city = newCity;
      this.originalLocation.show = true;
    },
    handleOpenModalChangePassword() {
      this.model.user.oldPassword = "";
      this.model.user.newPassword = "";
      this.model.user.newPasswordConfirmation = "";
      this.modals.modalChangePassword = true;
      this.modals.modalError = "";
    },
    newPasswordInputsMatch() {
      if (
        this.model.user.newPassword &&
        this.model.user.newPasswordConfirmation
      ) {
        return (
          this.model.user.newPassword ===
          this.model.user.newPasswordConfirmation
        );
      }
      return false;
    },
    async handleSubmitChangePassword() {
      this.modals.modalError = "";
      const loader = this.$loading.show({
        container: this.$refs.modal_change_password,
        width: 90,
        height: 90,
      });
      try {
        await api.put(`/users/${this.model.investor.user_id}`, this.model.user);
        this.$toasted.show("Senha atualizada com sucesso");
        this.success = "Alteração de senha realizada com sucesso.";
        this.modals.modalChangePassword = false;
      } catch (e) {
        const strError = "Ocorreu um erro ao atualizar a senha.";
        const hasErrorMessage = e.response && e.response.data;
        this.modals.modalError = hasErrorMessage ? e.response.data : strError;
        this.$toasted.error(strError);
      }
      loader.hide();
    },
  },
  computed: {
    getprofilePicturePath() {
      const defaultLogoPath = "/img/pages/default_profile_picture.png";
      const profilePicture = this.model.investor.profile_picture;
      if (!profilePicture) return defaultLogoPath;
      return profilePicture.url;
    },
  },
};
</script>
<style scoped>
.card-profile-image img {
  width: 180px;
  height: 180px;
  border-radius: 10%;
}

.jump {
  animation: jump 1.5s 0s forwards cubic-bezier(0.84, -0.54, 0.31, 1.19)
    infinite;
}

@keyframes jump {
  0% {
    transform: none;
  }
  50% {
    transform: translateY(-2em);
  }
}
</style>
